import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t bg-card/50 backdrop-blur-sm mt-20">
      <div className="container mx-auto px-4 py-6 text-center text-sm text-muted-foreground">
        <div>© 2025 PH Lim IgniteAITool. All rights reserved</div>
        <div className="mt-2">
          <Link to="/contact" className="text-primary hover:underline">Contact Support</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
